// Port of api/fuel/app/classes/controller/api/monty/groups/activity.php
import Activity from 'offline/filter/activity'
import F from 'offline/filter/constants'
import { buildFilterConfig } from 'offline/api/monty'

export default function(params) {
	var config = buildFilterConfig(params, F.OWNER_GROUP)

	if (!config) {
		return Promise.reject({ error: 'Owner not found in offline database', offline: true })
	}

	return Promise.resolve(Activity.forge(config).run().to_array({
		session: { offline: true }
	}))
}
